import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { fetchProjectList } from '../../api/admin';
import { RootState } from '../../redux/rootReducer';
import {
  formatDateToYYMMDD,
  formatDateWithDashes,
  formatDateWithFS,
} from '../../utils/helper';
import NewPaginationContainer from '../global-components/new-pagination';
import PageSizeDropdown from '../global-components/pageSizeDropDown';
import FilterNavProject from './filterNav';
import AddProjectModal from './AddProjectModal';

function Project() {
  const location = useLocation();
  const [addShowModal, setAddShowModal] = useState(false);
  const isAdmin = location?.pathname === '/app/admin/job-history';
  const userData: any = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const isVendor = userData?.is_vendor;
  const [projectHistoryData, setProjectHistoryData] = useState<any>();
  const [projectHistoryListData, setProjectHistoryListData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUserEmail, setSelectedUserEmail] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const pageSizeOptions: number[] = [25, 50, 75, 100, 125];
  const [handleToggleChange, setHandleToggleChange] = useState(false);
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();

  function handleFilter(query?: string) {
    setLoading(true);
    let payload = {
      is_pagination: true,
      page: currentPage,
      pageSize: pageSize,
      search: query ? query : searchQuery,
      owner: selectedUserEmail !== '' ? selectedUserEmail : undefined,
      start_date: startDate !== '' ? startDate : undefined,
      end_date: endDate !== '' ? endDate : undefined,
    };
    fetchProjectList(payload)
      ?.then((response) => {
        if (!response?.data?.is_error) {
          setLoading(false);
          setHandleToggleChange(false);
          setProjectHistoryListData(response.data.content);
          setProjectHistoryData(response.data.content.data);
        }
      })
      .catch((e) => {
        setHandleToggleChange(false);
        setLoading(false);
      });
  }
  const handleSearchField = (query: string) => {
    setSearchQuery(query);
    handleFilter(query);
  };
  useEffect(() => {
    handleFilter();
  }, [currentPage, pageSize]);

  return (
    <div className='container-fluid my-4'>
      <div className='row mt-4 mb-5'>
        <div className='col-12'>
          <div className=''>
            <div className='card-body p-4'>
              <FilterNavProject
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                selectedUserEmail={selectedUserEmail}
                setSelectedUserEmail={setSelectedUserEmail}
                handleFilter={handleFilter}
                handleSearchField={handleSearchField}
                setSearchQuery={setSearchQuery}
                searchTerm={searchQuery}
                isAdmin={isAdmin}
                isVendor={isVendor}
                fileName={''}
                setHandleToggleChange={setHandleToggleChange}
                handleToggleChange={handleToggleChange}
                clickHandler={() => {
                  setAddShowModal(true);
                }}
              />

              <div className=''>
                <table className='table ' id='shipment_table'>
                  <thead className='ubbe-table-header'>
                    <tr>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope='col'
                        style={{ width: '15%' }}
                      >
                        Code
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope='col'
                        style={{ width: '15%' }}
                      >
                        Name
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope='col'
                        style={{ width: '25%' }}
                      >
                        Description
                      </th>
                      <th
                        scope='col'
                        className={`text-start align-middle ubbe-table-heading-text`}
                        style={{ width: '12%' }}
                      >
                        Start Date
                      </th>
                      <th
                        scope='col'
                        className={`text-start align-middle ubbe-table-heading-text`}
                        style={{ width: '12%' }}
                      >
                        End Date
                      </th>
                      <th
                        scope='col'
                        className={`text-start align-middle ubbe-table-heading-text`}
                        style={{ width: '12%' }}
                      >
                        Owner
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope='col'
                        style={{ width: '5%' }}
                      ></th>
                    </tr>
                  </thead>
                  <tbody id='shipments_rows' className='legs'>
                    {projectHistoryData && projectHistoryData.length > 0 ? (
                      projectHistoryData.map((item: any, index: any) => (
                        <tr key={index}>
                          <td className='align-middle'>{item?.code}</td>
                          <td className='align-middle'>{item?.name}</td>
                          <td className='align-middle'>{item?.description}</td>
                          <td className='align-middle'>
                            {formatDateWithDashes(new Date(item?.start_date))}
                          </td>
                          <td className='align-middle'>
                            {formatDateWithDashes(new Date(item?.end_date))}
                          </td>
                          <td className='align-middle'>
                            {item?.owner ? item?.owner : 'N/A'}
                          </td>
                          <td className='align-middle'>
                            <Link
                              className='text-decoration-none'
                              to={`/app/project/view?project_id=${item['id']}`}
                            >
                              <u
                                className='labelText'
                                style={{ color: '#251163', fontSize: '16px' }}
                              >
                                Details
                              </u>
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : loading ? (
                      <tr className='text-center'>
                        <td colSpan={9}>
                          <div className='spinner-border' role='status'>
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td
                          colSpan={9}
                          className='text-center global-text align-middle '
                          style={{ color: ' #979797                      ' }}
                        >
                          Projects not found! Please try again.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className='d-flex justify-content-end align-items-center gap-2'>
                <PageSizeDropdown
                  setPageSize={setPageSize}
                  pageSizeOptions={pageSizeOptions}
                  currentSize={pageSize}
                  setCurrentPage={setCurrentPage}
                />
                {projectHistoryListData?.pages > 1 && (
                  <div className='d-flex align-items-center justify-content-end gap-3'>
                    <NewPaginationContainer
                      totalItems={projectHistoryListData?.count}
                      totalPages={projectHistoryListData?.pages}
                      currentPage={currentPage}
                      pageSize={pageSize}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {addShowModal && (
        <AddProjectModal
          onClose={() => {
            setAddShowModal(false);
          }}
          onSuccess={() => {
            setAddShowModal(false);
            handleFilter();
          }}
        />
      )}
    </div>
  );
}

export default Project;
